"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _TextFormattedReplace = _interopRequireDefault(require("../../../components/TextFormattedReplace"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    quantity: (0, _extends2.default)({}, theme.typography.body1, {
      fontWeight: 500
    })
  };
}, {
  name: 'ProductDetailShippingDateDefault'
});

function ProductDetailShippingDateDefault(_ref) {
  var pClasses = _ref.classes,
      shipping = _ref.shipping;
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var checkSameDate = function checkSameDate(d1, d2) {
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getYear() === d2.getYear();
  };

  var Today = function Today() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: classes.quantity
    }, t('productDetailPage/availability/todayWord'));
  };

  return (0, _cond.default)([[function (sh) {
    return (sh.warehouse === '1' || sh.warehouse === '2') && checkSameDate(sh.shippingDate, new Date());
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_TextFormattedReplace.default, {
      replaces: {
        // eslint-disable-next-line react/display-name
        time: function time() {
          return /*#__PURE__*/_react.default.createElement("span", {
            className: classes.quantity
          }, t('productDetailPage/availability/nextDateTime'));
        }
      }
    }, t('productDetailPage/availability/today', {
      time: '##time##'
    }));
  }], [function (sh) {
    return (sh.warehouse === '1' || sh.warehouse === '2') && checkSameDate(sh.shippingDate, (0, _addDays.default)(new Date(), 1));
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_TextFormattedReplace.default, {
      replaces: {
        today: Today
      }
    }, t('productDetailPage/availability/tomorrow', {
      today: '##today##'
    }));
  }], [function (sh) {
    return sh.warehouse === '1' || sh.warehouse === '2';
  }, function (_ref2) {
    var shippingDate = _ref2.shippingDate;
    return /*#__PURE__*/_react.default.createElement(_TextFormattedReplace.default, {
      replaces: {
        today: Today
      }
    }, t('productDetailPage/availability/dayOfWeek/message', {
      day: t("productDetailPage/availability/dayOfWeek/".concat(shippingDate.getDay())),
      today: '##today##'
    }));
  }], [function (sh) {
    return sh.warehouse === 'external';
  }, function (_ref3) {
    var _ref3$timing = (0, _slicedToArray2.default)(_ref3.timing, 3),
        minDays = _ref3$timing[1],
        maxDays = _ref3$timing[2];

    return /*#__PURE__*/_react.default.createElement(_TextFormattedReplace.default, {
      replaces: {
        today: Today
      }
    }, t('productDetailPage/availability/dateRange', {
      minDays: minDays,
      maxDays: maxDays,
      today: '##today##'
    }));
  }], [function () {
    return true;
  }, function () {
    return null;
  }]])(shipping);
}

process.env.NODE_ENV !== "production" ? ProductDetailShippingDateDefault.propTypes = {
  classes: _propTypes.default.shape({
    quantity: _propTypes.default.string
  }),
  shipping: _propTypes.default.shape({
    latestOrderTime: _propTypes.default.shape({}),
    shippingDate: _propTypes.default.shape({}),
    warehouse: _propTypes.default.string
  })
} : void 0;
ProductDetailShippingDateDefault.defaultProps = {
  classes: undefined,
  shipping: undefined
};
var _default = ProductDetailShippingDateDefault;
exports.default = _default;